<template>
  <nav class="fixed top-0 w-full bg-white/70 backdrop-blur-md z-50">
    <div
      class="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4"
    >
      <a
        href="/"
        class="text-2xl font-black bg-linear-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent tracking-tight"
      >
        <img src="/assets/logo.svg" class="h-5" title="YouClub" />
      </a>
      <div class="flex-1"></div>
      <div class="hidden md:flex gap-6 text-sm font-medium items-center">
        <a
          href="/start"
          class="flex items-center gap-2 bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-semibold hover:bg-pink-100 transition"
          >Start a Club</a
        >
        <a
          href="/signup"
          class="a"
          rel="external"
          @click.prevent="showLogin = 'signup'"
          v-if="!user"
          >Sign up</a
        >
        <a
          href="/my"
          class="a cursor-pointer transition rounded-full p-1 hover:bg-pink-100"
          v-else
        >
          <Avatar
            :name="user?.name"
            width="24"
            height="24"
            class="rounded-full"
          />
        </a>
      </div>
      <PopUp
        className="a cursor-pointer transition p-2 rounded hover:bg-pink-100"
      >
        <template #trigger>
          <svg width="20" height="20" viewBox="0 0 8 8">
            <path
              fill="currentColor"
              d="M0 2h9V1H0Zm0 6h9V7H0Zm0-3h9V4H0Zm0 0"
            />
          </svg>
        </template>
        <a
          href="/auth/signin"
          v-if="!user"
          @click.stop.prevent="showLogin = 'login'"
          rel="external"
          >Sign In</a
        >
        <a href="/my" v-else>My Account</a>
        <a href="/auth/signout" v-if="user">Signout</a>
        <a href="/help">Help &amp; Support</a>
        <a href="/terms.html" target="_blank">Terms Of Service</a>
        <a href="/privacy.html" target="_blank"> Privacy Policy</a>
      </PopUp>
    </div>
  </nav>
  <template v-if="showMenu">
    <div
      class="bg-gray-600/50 fixed top-0 right-0 bottom-0 left-0 z-50"
      @click="showMenu = false"
    ></div>
    <nav class="fixed top-0 right-0 bottom-0 w-64 bg-card border-l z-50 p-8">
      <h3 class="h3">Menu</h3>
      <ul>
        <li><a href="">Terms of service</a></li>
      </ul>
    </nav>
  </template>
  <AuthModal
    v-if="!user && showLogin"
    @close="showLogin = undefined"
    :xMode="showLogin"
  />
</template>
<script setup lang="ts">
import { ref } from "vue";
import AuthModal from "@/components/AuthModal.vue";
import PopUp from "@/lib/components/PopUp.vue";
import { useLoginState } from "@/pages/store";
import Avatar from "@/lib/components/Avatar.vue";

const showMenu = ref(false);
const { showLogin, user } = useLoginState();
</script>
